export function formatDateToBackend(date) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    return `${yyyy}-${mm}-${dd}`;
}

export function formatDateToFrontend(date) {
    const dd = String(date.getDate()).padStart(2, '0');
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const yyyy = date.getFullYear();

    return `${dd}/${mm}/${yyyy}`;
}

export function convertDateFormat(dateString) {
    const [day, month, year] = dateString.split(' ')[0].split('/');
    const [hours, minutes] = dateString.split(' ')[1].split(':');

    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
}

export function calculatePercentage(totalValue, targetedValue) {
    if (targetedValue === 0) {
        return 0;
    }
    return (totalValue / targetedValue) * 100;
}

// export const colors = [
//     '#FF6384', '#36A2EB', '#FFCE56', '#4BC0C0', '#9966FF',
//     '#FF9F40', '#FFCD56', '#4BC0C0', '#36A2EB', '#FF6384'
// ];

export const colors = [
    '#f44336', '#ffa500', '#6aa84f', '#2986cc', '#674ea7',
    '#1982c4', '#80d819', '#ff595e', '#6a4c93', '#0265ff'
];

export const openFileWithLoading = async ({
    apiCall,
    apiParams = [],
    fileType = 'pdf',
    loadingMessage = 'Generating file... Please wait',
    errorMessage = 'Failed to generate file. Please try again later.',
}) => {    
    let newTab;

    if (fileType === 'pdf') {
        newTab = window.open('', '_blank');
        if (!newTab) {
            alert('Please allow popups for this website');
            return;
        }

        newTab.document.write(`
            <center style="
                height: 100vh;
                display: flex;
                justify-content: center;
                align-items: center;
                font-family: sans-serif;
                font-size: 1.2rem;
            ">
                ${loadingMessage}
            </center>
        `);
    }

    try {
        const data = await apiCall(...apiParams);        

        if (!data?.error) {
            if (fileType === 'pdf' && data?.pdfUrl) {
                newTab.location.href = data.pdfUrl;
            } else if (fileType === 'csv' && data?.csvUrl) {
                window.open(data.csvUrl, '_blank');
            } else {
                if (fileType === 'pdf') {
                    newTab.document.body.innerHTML = `<center><p style="color:red;">${errorMessage}</p></center>`;
                } else {                    
                    console.error("Error Generating CSV: ", errorMessage);
                }
            }
        } else {
            if (fileType === 'pdf') {
                newTab.document.body.innerHTML = `<center><p style="color:red;">${errorMessage}</p></center>`;
            } else {                
                console.error("Error Generating CSV: ", errorMessage);
            }
        }
    } catch (err) {
        console.error('Error generating file', err);
        if (fileType === 'pdf' && newTab) {
            newTab.document.body.innerHTML = `<center><p style="color:red;">${errorMessage}</p></center>`;
        } else {
            console.error("Error Generating CSV: ", errorMessage);
        }
    }
};